module.exports = __webpack_public_path__ + "static/media/Picverse-image-2-s.7b45430a.jpg";